export const ACCESS_TOKEN = 'accessToken';
export const EXPIRES_ON = 'expiresOn';
export const ACCOUNT = 'account';
export const TIME_OF_AUTO_LOGOUT = 'timeOfAutoLogout';
export const LOGOUT_IN_PROCESS = 'logoutInProcess';
export const SITE_ID = 'siteId';
export const USER_ROLE = 'userRole';
